import React from 'react';
import './styles.css';





export const NoraAyudanteDerecha = () => {


  return (
    <>


        <div className='NoraAyudanteDerecha-Container'>

              <div className='NoraAyudanteDerecha-nombre-texto-container'>
                  
                    <div className='NoraAyudanteDerecha-nombre' />

                    <div className='NoraAyudanteDerecha-texto'>

                          <div className='NoraAyudanteDerecha-texto-subcontainer'>

                              Educadora infantil.Tutora del aula de 2-3 años.

                          </div>
                          
                    </div> 

              </div>

              <div className='NoraAyudanteDerecha-maestra' />
            
        </div>


    </>
  )
}
